// Central clinic data — easy to update
export const CLINIC = {
  name: "בית הרופאים באקה",
  nameHe: "בית הרופאים באקה",
  tagline: "Pain and rehabilitation",
  phone: "073-277-7600",
  mobile: "050-236-6404",
  whatsapp: "972502366404",
  email: "info@painur.com",
  address: "רח' ביר בורין 196, באקה אל גרבייה",
  shopUrl: "https://www.painur.com/courses",
  externalSite: "https://www.painur.com",
  facebook: "https://www.facebook.com/profile.php?id=100063893868750",
  instagram: "https://www.instagram.com/dima_painache/",
  waze: "https://www.waze.com/he/live-map/directions?to=ll.32.419302%2C35.035765",
} as const;

export const services = [
  {
    slug: "pain-relief",
    title: "שיכוך כאב",
    short: "טיפול ייעודי על ידי רופא מומחה לשיכוך כאב",
    description:
      "ניתן על ידי רופא מתמחה לשיכוך כאב. המערך מפעיל מרפאה ומעניק ייעוץ וטיפול מקיף. הטיפול ניתן על ידי צוות רפואי במטרה להחזיר את המטופל למעגל החיים ולתפקוד מלא ככל שניתן.",
    icon: "Activity",
  },
  {
    slug: "speech",
    title: "קלינאי/ת תקשורת",
    short: "אבחון וטיפול בהפרעות תקשורת ושפה",
    description:
      "המומחה המאבחן ומטפל בהפרעות תקשורת: הפרעות בשפה, בהגייה, הפרעות קוליות, הפרעות תקשורת ממקור עצבי והפרעות בליעה.",
    icon: "Mic",
  },
  {
    slug: "physiotherapy",
    title: "פיזיותרפיה",
    short: "אבחון, טיפול ומניעה של בעיות תנועה ותפקוד",
    description:
      "מקצוע הפיזיותרפיה עוסק באבחון, טיפול ומניעה של בעיות הקשורות לתפקוד היומיומי ומערכות התנועה, שיקום וחזרה לתפקוד מלא לאחר פציעה, ניתוח או מחלה. פתרונות שיקומיים בתחומים אורתופדיים, נוירולוגיים, נשימה, שיווי משקל ומערכת השתן.",
    icon: "Dumbbell",
  },
  {
    slug: "chinese-medicine",
    title: "רפואה סינית ומשלימה",
    short: "תחום רחב של פרקטיקות רפואה משלימה",
    description:
      "הרפואה הסינית היא תחום רחב של פרקטיקות מתחום הרפואה האלטרנטיבית, שנעשה בהן שימוש למעלה מ-2,000 שנה. כולל שימוש בצמחי מרפא, דיקור, טיפול במגע, תרגול גופני ועצות תזונתיות.",
    icon: "Leaf",
  },
  {
    slug: "plasma",
    title: "טיפול בפלזמה",
    short: "PRP / PRF / Growth Cell — קרם אישי מהדם שלך",
    description:
      "הטיפול היחיד בארץ שנותן לך קרם אישי מהדם שלך לשימוש ביתי. מרפא רקמות פגומות, מאיץ חילוף חומרים בתאים וייצור קולגן ואלסטין — האחראים למיצוק העור ושמירת האלסטיות. תוצאות ארוכות טווח, מתאים לכל אזורי הגוף.",
    icon: "Droplets",
  },
  {
    slug: "nlp",
    title: "טיפול NLP",
    short: "תהליך ממוקד לשינוי דפוסים, חיזוק משאבים והתמודדות רגשית",
    description:
      "טיפול NLP מסייע בזיהוי ושינוי דפוסי חשיבה, רגש והתנהגות, במטרה לחזק ביטחון עצמי, לשפר תקשורת פנימית וחיצונית ולהתקדם לעבר מטרות אישיות בצורה ממוקדת ומעשית.",
    icon: "Activity",
  },
  {
    slug: "expressive-arts-therapy",
    title: "טיפול הבעה ויצירה (טיפול רגשי)",
    short: "מרחב טיפולי רגשי באמצעות הבעה, יצירה וכלים מותאמים אישית",
    description:
      "טיפול הבעה ויצירה מאפשר עיבוד רגשי, חיזוק תחושת המסוגלות וביטוי אישי דרך כלים יצירתיים מגוונים, בסביבה מקצועית, בטוחה ומכילה המותאמת לצורכי המטופל.",
    icon: "HandHeart",
  },
  {
    slug: "podiatry",
    title: "פדיקור רפואי",
    short: "טיפול מקצועי בבעיות רפואיות בכף הרגל",
    description:
      "טיפול בבעיות רפואיות במעטפת כף הרגל: הורדת עור קשה/סדוק, גזירה ושיוף ציפורניים מעובות או פטרייתיות, הוצאת ציפורניים חודרניות וטיפול בדלקות ובשר פרא בציפורניים.",
    icon: "Footprints",
  },
  {
    slug: "occupational-therapy",
    title: "ריפוי בעיסוק",
    short: "השבת תפקוד ועצמאות לחיי היומיום",
    description:
      "ריפוי בעיסוק הוא מקצוע ממקצועות הבריאות שמטרתו השגה, שימור והשבת האדם לתפקוד בעיסוקים המשמעותיים עבורו. סיוע לאנשים בעלי הפרעה בתפקוד עקב לקות פיזית, נפשית, קוגניטיבית או תקשורתית — לחיות חיים עצמאיים במשפחה ובחברה.",
    icon: "HandHeart",
  },
] as const;

import bashirImg from "@/assets/team/bashir.jpg";
import samahImg from "@/assets/team/samah.jpg";
import abuHusseinImg from "@/assets/team/abu-hussein.jpg";
import wegdanImg from "@/assets/team/wegdan.jpg";
import omarImg from "@/assets/team/omar.jpg";
import amaniImg from "@/assets/team/amani.jpg";
import mayImg from "@/assets/team/may.jpg";
import fahedImg from "@/assets/team/fahed.jpg";
import anasImg from "@/assets/team/anas.jpg";
import rolaImg from "@/assets/team/rola.jpg";
import sobhiaImg from "@/assets/team/sobhia.jpg";

export const team = [
  {
    name: "ד״ר מואסה בשיר",
    role: "מומחה ברפואה דחופה ומתמחה ברפואת שיכוך כאב",
    initials: "מב",
    image: bashirImg,
  },
  {
    name: "סמאח מואסה",
    role: "ריפוי בעיסוק",
    initials: "סמ",
    image: samahImg,
  },
  {
    name: "ד״ר אבו חוסיין מרח",
    role: "רופאת משפחה",
    initials: "אח",
    image: abuHusseinImg,
  },
  {
    name: "וגדאן מואסי",
    role: "ND — מטפלת ברפואה משלימה וסינית, תזונאית טבעית ונטורופתית",
    initials: "וג",
    image: wegdanImg,
  },
  {
    name: "עומר כבהא",
    role: "מרפא בעיסוק",
    initials: "עכ",
    image: omarImg,
  },
  {
    name: "אמאני ותד",
    role: "פיזיותרפיסטית",
    initials: "אמ",
    image: amaniImg,
  },
  {
    name: "מאי אגבאריה",
    role: "מרפאה בעיסוק B.O.T",
    initials: "מא",
    image: mayImg,
  },
  {
    name: "ד״ר עתאמנה פהד",
    role: "מומחה בטיפולים רגנרטיביים — PRP / PRF / CGF",
    initials: "עפ",
    image: fahedImg,
  },
  {
    name: "אנס כבהא",
    role: "קלינאי תקשורת",
    initials: "אנ",
    image: anasImg,
  },
  {
    name: "רולא סורה",
    role: "קלינאית תקשורת",
    initials: "רס",
    image: rolaImg,
  },
  {
    name: "סובחייה מואסי אבו בדר",
    role: "צוות המרפאה",
    initials: "סא",
    image: sobhiaImg,
  },
] as const;

export const testimonials = [
  {
    name: "Hitam Abu snina",
    date: "2025-11-17",
    text: "קורס מלמד, למדנו הרבה דברים חדשים. רופא מקצוען, אדיב, עונה לשאלות בנימוס וסבלני. אדם נכון במקום הנכון. תודה רבה!",
  },
  {
    name: "Ola Lubany",
    date: "2025-11-16",
    text: "ההרצאה הייתה מצוינת וסיפקה לנו המון מידע בעל ערך. תודה!",
  },
  {
    name: "Mohamad Taha",
    date: "2025-09-26",
    text: "כל הכבוד וההערכה לדוקטור בשיר על המאמץ וההסבר הפשוט והמדויק.",
  },
  {
    name: "Marwa Awisat",
    date: "2025-05-03",
    text: "קורס מדהים — נהנינו מאוד והאווירה הייתה מעולה 💐",
  },
  {
    name: "Riham Egbariah",
    date: "2025-05-03",
    text: "תודה רבה על המקצועיות והלימוד ברמה גבוהה.",
  },
  {
    name: "niveen Gbareen",
    date: "2025-05-03",
    text: "זאת לא הפעם הראשונה שאני מקבלת קורס אצל ד״ר בשיר, והיום קיבלתי קורס אוקסיזום — וכמו תמיד היה מצוין. אשמח לחזור בכל פעם שיהיה משהו חדש.",
  },
  {
    name: "haneen jaber",
    date: "2025-05-03",
    text: "תודה לדוקטור בשיר על הקורס המקצועי. צוות מדהים, מרפאה מעולה!",
  },
] as const;
